// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3XfTK","range":"MonthRangeSwitch_range__2mZuY","disabled":"MonthRangeSwitch_disabled__17mso"};